import {useMediaQuery, useTheme} from '@mui/material';

export default function useMobile(): boolean {
  return useMediaQuery(useTheme().breakpoints.down('md'));
}
